import React, { useEffect } from 'react';
import { KTIcon } from '../_metronic/helpers';
import { DrawerComponent } from '../_metronic/assets/ts/components'; // Metronic ka core component tracker

const OffCanvas = (props: any) => {
    const { name, width, componentName } = props.obj;
    const { isOpen } = props;    
    useEffect(() => {
        DrawerComponent.reinitialization();
    }, [width, isOpen]);

    return (
        <>
            <div
                id='kt_OffCanvas_Main'
                className='bg-body'
                data-kt-drawer='true'
                data-kt-drawer-name='chat'
                data-kt-drawer-activate='true'
                data-kt-drawer-overlay='true'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_OffCanvas'
                data-kt-drawer-close='#kt_OffCanvas_close'
                style={{
                    zIndex: 2000,
                    width: width || '500px', 
                    maxWidth: '100%'
                }}
            >
                <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
                    <div className='card-header pe-5' id='kt_drawer_chat_messenger_header'>
                        <div className='card-title'>
                            <div className='d-flex justify-content-center flex-column me-3'>
                                <a className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                                    {name}
                                </a>
                            </div>
                        </div>
                        <div className='card-toolbar'>
                            <div className='btn btn-sm btn-icon btn-active-light-primary' id='kt_OffCanvas_close'>
                                <KTIcon iconName='cross' className='fs-2' />
                            </div>
                        </div>
                    </div>
                    {componentName}
                </div>
            </div>
        </>
    )
}

export default OffCanvas;